var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 29,
    viewBox: "0 0 21 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0186 4.80739H16.1219V1.85894C16.1219 1.12183 15.5241 0.679565 14.9262 0.679565C14.3284 0.679565 13.7306 1.26926 13.7306 1.85894V4.80739H7.90201V1.85894C7.90201 1.12183 7.30421 0.679565 6.7064 0.679565C6.1086 0.679565 5.51078 1.26926 5.51078 1.85894V4.80739H4.61408C2.52175 4.80739 0.728333 6.57646 0.728333 8.64038V24.2672C0.728333 26.3311 2.52175 28.1001 4.61408 28.1001H17.0186C19.1109 28.1001 20.9043 26.3311 20.9043 24.2672V8.64038C20.9043 6.57646 19.2603 4.80739 17.0186 4.80739ZM18.5131 24.2672C18.5131 25.0043 17.9153 25.7414 17.0186 25.7414H4.61408C3.86682 25.7414 3.11956 25.1517 3.11956 24.2672V12.6208H18.3636V24.2672H18.5131Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedCalendar);
export default __webpack_public_path__ + "static/media/selected-calendar.8c6ce6779b71a2e10ce9d4d850daa73d.svg";
export { ForwardRef as ReactComponent };